<div class="modal-body modal-template-inner-body" [ngClass]="editModeBorder ? 'dashed-border' : ''"
  role="dialog" aria-modal="true" cdkTrapFocus [cdkTrapFocusAutoCapture]="true"
  [attr.aria-labelledby]="!customizeHeader ? dialogTitleId : null"
  [attr.aria-label]="customizeHeader ? title : null">
  <div class="modal-header d-flex justify-content-center align-items-center">
    <div class="header-title-cont" *ngIf="!customizeHeader">
      <span class="lato-20-n-vw header-title text-capitalize" [id]="dialogTitleId">{{ title
        }}</span>
    </div>
    <div class="header-title-cont customize-header" *ngIf="customizeHeader">
      <ng-container *ngTemplateOutlet="headerContentRef;"></ng-container>
    </div>
    <div class="cross-btn-cont" (click)="closeModalTemplate()" *ngIf="crossBtnVisibility"
      role="button" tabindex="0" aria-label="Close modal"
      (keydown.enter)="closeModalTemplate(); $event.preventDefault()"
      (keydown.space)="closeModalTemplate(); $event.preventDefault()">
      <div cygovSvgIcon [svgName]="'x-icon-type2'" class='cross-btn'></div>
    </div>
  </div>
  <div class='modal-content-body'>
    <ng-container *ngTemplateOutlet="contentRef;"></ng-container>
  </div>

  <div class="modal-content-footer">
    <ng-container *ngTemplateOutlet="footerContentRef;"></ng-container>
  </div>
</div>